/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */

import ClientSearch from "../icons/menu/client_search.svg";
import OrderSearch from "../icons/menu/order_search.svg";
import * as ROUTES from "../constants/routes";

export const MenuBlocks = [
  {
    items: [
      {
        name: "Órdenes",
        icon: OrderSearch,
        link: ROUTES.ORDER,
      },
      {
        name: "Inventario",
        icon: ClientSearch,
        link: ROUTES.INVENTORY,
      },
    ],
  },
];
